<template>
    <div class="content-body customers-wrapper customer-list">
        <b-row>
            <b-col v-for="statistic in statistics" :key="statistic.display" sm="6" md="3" class="mb-5">
                <stat-card :icon="statistic.icon" :note="statistic.note" :value="statistic.value"
                    :title="statistic.display" :icon-bg-color="statistic.iconBgColor" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <i class="icon-calendar"></i>
                    </b-input-group>
                    <datepicker :config="daterangeConfig" :v-model="filter.date">
                    </datepicker>
                </b-input-group>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                        <b-form-input placeholder="Search" v-model="filter.keyword" @keyup.native="
                            !filter.keyword.trim() &&
                                storedFilter.keyword &&
                                (filter.keyword.trim() !== storedFilter.keyword)
                                ? search($event)
                                : null" @keyup.enter="doSearch()">
                        </b-form-input>
                        <b-dropdown text="Advanced" variant="primary" slot="append">
                            <b-dropdown-item v-for="(field, index) in searchFields" :key="index"
                                @click="filter.filter = field.key">
                                {{ field.label }}
                                <i v-if="filter.filter === field.key" class="ml-1"> <img width="15" height="15"
                                        src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                </i>
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button slot="append" variant="primary" class="h-100" @click.self="search"
                            :disabled="isDisabledSearchButton">
                            Search
                        </b-button>
                    </b-input-group>
                </div>
            </b-col>
            <b-col md="6" class="text-left text-md-right">
                <span class="csv-tooltip">
                    CSV <downloadexcel class="template-button" :fields="json_fields" :data="json_data" type="csv"
                        name="customer_import_template.csv">
                        (Template)
                    </downloadexcel>
                    <b-btn variant="ghost"
                        v-b-popover.hover="'Import or export list of your customers in excel CSV format'" title="">
                        <i class="ic-tooltip" id="csv"></i>
                    </b-btn>
                </span>
                <b-form-file v-model="importCsv" hidden accept=".csv" ref="importCsv">
                </b-form-file>
                <b-button class="mr-3" variant="tertiary btn-table-import-activation-key" @click="openModal">
                    Import
                </b-button>
                <b-button variant="tertiary btn-table-export-activation-key" @click="exportCustomer">Export</b-button>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table :items="loading ? [] : list" :fields="showFields()" :current-page="page" ref="customerList"
                    responsive show-empty :empty-text="emptyText || emptySearch">
                    <template slot="company_code" slot-scope="data">
                        {{ data.value == '' || data.value == null ? 'Not Available' : data.value }}
                    </template>
                    <template slot="deactivation_channel" slot-scope="data">
                        <template v-if="data.value === 'web'">
                            Website
                        </template>
                        <template v-if="data.value === 'ios'">
                            iOS App
                        </template>
                        <template v-if="data.value === 'android'">
                            Android App
                        </template>
                        <template v-if="data.value === 'glife'">
                            GLife
                        </template>
                    </template>
                    <template slot="deleted_at" slot-scope="data">
                        <template v-if="data.value">
                            {{ moment(data.value).format("lll") }}
                        </template>
                    </template>
                    <template slot="action" slot-scope="data">
                        <b-button variant="ghost btn-table-edit" v-b-modal="'edit-customer'"
                            @click="editCustomer(data.item.uuid)">
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
        <div>
            <b-row>
                <b-col>
                    <div class="mt-1">
                        <span class="pagination-indicator">{{ startList }}-{{ endList }} of {{ maxPage }} per
                            page</span>
                            
                        <b-pagination hide-goto-end-buttons align="left" size="md" :total-rows="maxPage * list.length"
                            :limit="3" :per-page="list.length" @change="paginate" :value="page" class="custom-pagination-arrow-only mb-0 ml-2">
                        </b-pagination>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="notification-success-import">
            <notifications width="445px" classes="notif-import" group="success-import" position="bottom left"
                style="left: 224px;" />
        </div>
        <div class="notification-upload-import">
            <notifications width="445px" classes="upload-import" group="uploading-import" position="bottom right" />
        </div>
        <b-modal id="edit-customer" size="lg modal-xlg" body-class="p-0 overflow-auto" content-class="p-0" hide-header
            hide-footer @show="customerModal" @shown="customerModal" @hide="customerModalClose" ref="CustomerModal">
            <b-container fluid>
                <b-row>
                    <b-col md="3" class="pt-3 px-3 border-right">
                        <div class="profile-wrap text-center">
                            <div class="lead font-weight-bold mb-3">Customer Profile</div>
                            <div class="profile-img mb-2 d-inline-flex position-relative">
                                <img :src="customer.profile_image" alt="" ref="customerProfileImg"
                                    class="position-absolute"
                                    :class="{ 'max-w100': customerModalImg.hGw, 'max-h100': customerModalImg.wGh }">
                            </div>
                            <p class="profile-name text-center mb-2">{{ customer.firstname }} {{ customer.lastname }}
                            </p>
                        </div>
                        <div class="profile-box mt-3 mb-3">
                            <div class="box-icon transactions"></div>
                            <div class="box-details">
                                <div class="box-title">Transaction Count</div>
                                <div class="box-value" :value="getCustomerTransactionCount(customer.uuid)">{{
                                    historyCount}}
                                </div>
                            </div>
                        </div>
                        <div class="profile-box mt-3 mb-3">
                            <div class="box-icon peso"></div>
                            <div class="box-details">
                                <div class="box-title">Amount Spent</div>
                                <div class="box-value">{{ amountSpent }}</div>
                            </div>
                        </div>
                        <div class="profile-box mt-3 mb-3">
                            <div class="box-icon points"></div>
                            <div class="box-details">
                                <div class="box-title">Current Total Points</div>
                                <div class="box-value">{{ currentBalance }}</div>
                                <hr>
                                <div class="box-title">Points Earned</div>
                                <div class="box-value">{{ pointEarned }}</div>
                                <hr>
                                <div class="box-title">Points Redeemed</div>
                                <div class="box-value">{{ pointsRedeemed }}</div>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="9" class="pt-3 pb-0 px-0">
                        <b-container fluid class="d-flex justify-content-end px-3">
                            <div class="border border-muted rounded px-2 py-1 shadow-sm cursor-pointer"
                                @click="$refs.CustomerModal.hide()">
                                <i class="bi bi-x h4" aria-hidden="true"></i>
                            </div>
                        </b-container>
                        <div class="profile-tabs">
                            <b-tabs v-model="selectedTabIndex">
                                <b-tab title="Profile Details">
                                    <customer-profile-tab v-bind:profile="form" :merchantUuid="merchantUuid"
                                        v-if="customer.uuid" :key="customer.uuid">
                                    </customer-profile-tab>
                                </b-tab>
                                <b-tab title="Transaction History">
                                    <b-row>
                                        <b-col sm="5" md="4">
                                            <b-input-group>
                                                <b-input-group slot="append">
                                                    <i class="icon-calendar"></i>
                                                </b-input-group>
                                                <datepicker ref="soloDatepicker" :config="daterangeConfigHistory">
                                                </datepicker>
                                            </b-input-group>
                                        </b-col>
                                        <b-col sm="5" md="4"></b-col>
                                        <b-col sm="5" md="4" class="text-left text-md-right">
                                            <b-button variant="primary btn-table-export"
                                                @click="exportTransactionHistory(selectedCustomer)">Export</b-button>
                                        </b-col>
                                    </b-row>
                                    <customer-history-tab v-bind:uuid="customer.uuid"
                                        v-if="customer.uuid"></customer-history-tab>
                                </b-tab>
                                <b-tab title="Stores" v-if="permission.hasAccess('customer.stores')">
                                    <Stores @openAddstore="AddStore" @openEditStore="EditStore">
                                    </Stores>
                                </b-tab>
                                <b-tab title="Card Numbers" v-if="privilegeCard">
                                    <CardNumbers :customerUuid="customer.uuid" :cardNumbers="cardNumbers">
                                    </CardNumbers>
                                </b-tab>
                                <b-tab title="RUSH Wallet">
                                    <wallet />
                                </b-tab>
                                <b-tab title="SC/PWD ID">
                                    <SpecialDiscountIdList @open-preview-modal="togglePreviewModal"
                                        @open-id-confirmation-modal="toggleIdConfirmationModal" />
                                </b-tab>
                            </b-tabs>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal size="modal-special" centered v-if="selectSdId" v-model="openPreviewIdModal">
            <div class="d-flex justify-content-center align-items-center"
                style="flex-direction: column; row-gap: 10px;">

                <!-- placeholder center crop image -->
                <!-- width: 342px; height: 221px; object-fit: cover; object-position: center; -->
                <img style="width: 70%; height: 50%; border-radius: 10px; " :src="imagePreview" alt="id_preview"
                    @error="imageError($event)">

                <div style="align-items: center; align-content: center; justify-content: center;"><span
                        style="font-family: MainFontRegular, sans-serif;font-size: 16px;color: #2F3941;">Uploaded on {{
                            formatDate(selectSdId.created_at) }}</span></div>
                <div class="d-flex justify-content-center align-items-center" style="">
                    <div @click="imagePreview = selectSdId.customer_image_front"
                        style="position: relative; width: 75px; height: 75px; overflow: hidden; border-radius: 10px; margin-right: 12px; ">
                        <img v-bind="imageProps" :src="selectSdId.customer_image_front" alt="id_front"
                            @error="imageError($event)"
                            style="position: absolute; top: 50%; left: 50%; width: 100%; height: 200px; transform: translate(-50%, -50%); object-fit: cover; object-position: center;" />

                    </div>



                </div>
            </div>
            <div></div>
            <div slot="modal-footer" class="d-flex flex-column justify-content-center align-items-center">
            </div>
        </b-modal>
        <b-modal id="idCdsad" @click="" centered class="id-preview-modal d-flex flex-column align-items-center"
            v-model="openIdConfirmationModal">
            <div>
                <div class="mx-auto">
                    <p class="text-center font-weight-bold" style="font-size: 24px; font-family: MainFontRegular, sans-serif;">
                        {{
                        capitalizeFirstLetter(idAction) }} Special Discount</p>
                </div>
                <div class="mx-auto">

                    <p class="text-center" style="font-size: 16px; font-family: MainFontRegular, sans-serif;">Are you sure you
                        want to
                        {{ idAction }} this <span class="d-block">Special Discount Application?</span></p>
                </div>
            </div>
            <template slot="modal-footer">

                <b-button class=""
                    style="font-size: 16px; font-family: MainFontBold, sans-serif; font-weight: normal; min-width: 40%"
                    variant="outline-secondary" @click="openIdConfirmationModal = false">{{ idAction == 'void' ? 'Keep'
                        : idAction == 'reject' ? 'Keep' : 'No'}}</b-button>
                <b-button class="" :style="{
                    fontSize: '16px',
                    fontFamily: 'DM Sans, sans-serif',
                    fontWeight: 700,
                    backgroundColor: idAction == 'void' ? '#CE0E2D' : idAction == 'reject' ? '#CE0E2D' : '#FF6B00',
                    borderColor: idAction == 'void' ? '#CE0E2D' : idAction == 'reject' ? '#CE0E2D' : '#FF6B00',
                    minWidth: '40%'
                }" @click="updateSpecialdDiscountId">{{ idAction == 'void' ? 'Void' : idAction == 'reject' ? 'Reject' : 'Yes'
                    }}</b-button>
                <div class="d-flex ">
                </div>
            </template>
        </b-modal>
        <b-modal id="upload-file" title="Upload File" ref="uploadFileModal" hide-footer centered>
            <b-container fluid id="upload-file-container">
                <div class="modal-form">
                    <b-form class="mb-2">
                        <div id="file-input-container" class="p-3 mb-2" v-bind:class="{ 'hide-label': file != null }">
                            <b-form-file v-model="file" ref="fileinput"
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                placeholder="Drop your file here or " @change="validateFile" />
                        </div>
                        <div v-bind:class="{ 'd-none': file == null }" class="mb-4">
                            <div class="d-inline-block file-name-container">
                                <img class="d-inline-block upload-file-icon" width="16" height="20"
                                    src="@/assets/images/icons/ic-upload-file.svg" alt="">
                                <div class="ml-2 d-inline-block upload-file-name" v-if="file != null">
                                    {{ file.name }}
                                </div>
                            </div>
                            <div class="d-inline-block cancel-file-upload-container">
                                <span>{{ formatBytes(file) }}</span>
                                <img width="15" height="15" src="@/assets/images/icons/cancel-file-upload.svg" alt=""
                                    @click="cancelFileUpload()" class="cancel-file-upload-icon">
                            </div>
                        </div>
                        <b-form-group :invalid-feedback="errorMessage('file')" :state="validationState('file')">
                        </b-form-group>
                        <hr class="my-4">
                        <div class="modal-form">
                            <b-row no-gutters>
                                <b-col cols="2">
                                    <switches theme="custom" v-model="is_sms" color="primary" type-bold="true"
                                        text-enabled="On" text-disabled="Off" style="top: -26px;">
                                    </switches>
                                </b-col>
                                <b-col>
                                    <b-form-group label="Send via SMS" class="secondary-label">
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row no-gutters style="margin-top: -15px;">
                                <b-col cols="2">
                                    <switches theme="custom" v-model="is_in_app" color="primary" type-bold="true"
                                        text-enabled="On" text-disabled="Off" style="top: -26px;">
                                    </switches>
                                </b-col>
                                <b-col>
                                    <b-form-group label="Send via In-App Message" class="secondary-label">
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                    </b-form>
                    <img class="d-inline-block upload-file-folder-icon" width="42" height="42"
                        src="@/assets/images/icons/ic-folder.svg" alt="">
                    <label class="shown-label" v-bind:class="{ 'd-none': file == null }">Drop your file here or
                        <span>browse</span></label>
                    <b-btn id="upload-file-button" variant="primary"
                        v-bind:disabled="loading || file == null || !!errors" @click="uploadFile"
                        class="btn-block mx-auto">
                        <template v-if="loading">
                            Uploading...
                        </template>
                        <template v-else>
                            Upload File
                        </template>
                    </b-btn>
                </div>
            </b-container>
        </b-modal>
        <AddStore :open="store_modal.new.status" @cancelAddStore="cancelAddStore">
        </AddStore>
        <EditStore :open="store_modal.edit.status" @cancelEditStore="cancelEditStore">
        </EditStore>
        <DeleteStore :open="store_modal.delete.status" @cancelDeleteStore="cancelDeleteStore">
        </DeleteStore>
    </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vue-bulma-datepicker";
import { mapState, mapGetters } from "vuex";
import CustomerProfile from "./CustomerProfileTab";
import TransactionHistoryTab from "./CustomerTransactionHistoryTab";
import Stores from "./stores/CustomerStoresTab";
import CardNumbers from "./stores/CardNumbersTab";
import AddStore from "./stores/AddStore";
import EditStore from "./stores/EditStore";
import DeleteStore from "./stores/DeleteStore";
import downloadexcel from "vue-json-excel";
import Switches from "vue-switches";
import StatCard from "@/components/common/StatCard.vue";
import Wallet from "@/components/customers/Wallet";
import SpecialDiscountIdList from "@/components/customers/SpecialDiscountIdList";
import permission from "../../services/user.permission";
import commonMixins from "@/mixins/common";

const customersTransaction = [
    {
        date: "Aug 3, 2018 1:30 PM",
        transaction_no: "0000001",
        activity:
            "Achievement unlocked! Earned 50 points for connecting with Facebook",
        employee_id: "23424-74"
    }
];
const transactionHistoryFilter = [
    {
        value: 0,
        text: "All Transactions"
    }
];

function initFilter() {
    return {
        keyword: null,
        filter: "all",
        dateFrom: null,
        dateTo: null
    };
}

export default {
    name: "Customers",
    mixins: [commonMixins],
    components: {
        "customer-profile-tab": CustomerProfile,
        "customer-history-tab": TransactionHistoryTab,
        Datepicker,
        downloadexcel,
        Stores,
        CardNumbers,
        AddStore,
        EditStore,
        DeleteStore,
        Switches,
        StatCard,
        Wallet,
        SpecialDiscountIdList
    },
    data() {
        let self = this;

        return {
            openPreviewIdModal: false,
            openIdConfirmationModal: false,
            idAction: "approve",
            selectedIdUuid: null,
            selectSdId: null,
            imagePreview: null,
            imageProps: { width: 120, height: 120 },
            is_sms: false,
            is_in_app: false,
            file: null,
            filename: "",
            json_fields: {
                "First Name": "first_name",
                "Last Name": "last_name",
                "Mobile Number": "mobile_number",
                Email: "email",
                Birthdate: "birthdate",
                Gender: "gender",
                "Membership ID": "membership_id"
            },
            json_data: [
                {
                    first_name: " ",
                    last_name: " ",
                    mobile_number: " ",
                    email: " ",
                    birthdate: " ",
                    gender: " ",
                    membership_id: " "
                }
            ],
            timeout: 500,
            filter: initFilter(),
            searchFields: [
                {
                    key: "all",
                    label: "All"
                },
                {
                    key: "firstname",
                    label: "First Name"
                },
                {
                    key: "lastname",
                    label: "Last Name"
                },
                {
                    key: "email",
                    label: "Email"
                },
                {
                    key: "mobile_number",
                    label: "Mobile Number"
                },
                {
                    key: "registration_channel",
                    label: "Registration Channel"
                }
            ],
            fields: [
                {
                    key: "membership_id",
                    sortable: true,
                    label: "Membership ID"
                },
                {
                    key: "firstname",
                    sortable: true,
                    label: "First Name"
                },
                {
                    key: "lastname",
                    sortable: true,
                    label: "Last Name"
                },
                {
                    key: "email",
                    sortable: true,
                    label: "Email"
                },
                {
                    key: "mobile_number",
                    sortable: true,
                    label: "Mobile Number"
                },
                {
                    key: "registration_channel",
                    sortable: true,
                    label: "Registration Channel"
                },
                {
                    key: "deactivation_channel",
                    label: "Deleted Account Channel",
                    sortable: true
                },
                {
                    key: "deleted_at",
                    label: "Deleted Account Date & Time",
                    sortable: true
                },
                "action"
            ],
            generikaFields: [
                {
                    key: "membership_id",
                    sortable: true,
                    label: "Membership ID"
                },
                {
                    key: "firstname",
                    sortable: true,
                    label: "First Name"
                },
                {
                    key: "lastname",
                    sortable: true,
                    label: "Last Name"
                },
                {
                    key: "email",
                    sortable: true,
                    label: "Email"
                },
                {
                    key: "mobile_number",
                    sortable: true,
                    label: "Mobile Number"
                },
                {
                    key: "registration_channel",
                    sortable: true,
                    label: "Registration Channel"
                },
                {
                    key: "registration_branch_name",
                    label: "Branch Registration",
                    sortable: true
                },
                {
                    key: "company_code",
                    label: "Company Code",
                    sortable: true
                },
                {
                    key: "deactivation_channel",
                    label: "Deleted Account Channel",
                    sortable: true
                },
                {
                    key: "deleted_at",
                    label: "Deleted Account Date & Time",
                    sortable: true
                },
                "action"
            ],
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"],
                onChange: function (selectedDates) {
                    let filterDate = selectedDates;
                    self.filter.dateFrom = self
                        .$moment(filterDate[0])
                        .format("YYYY-MM-DD");
                    self.filter.dateTo = self
                        .$moment(filterDate[1])
                        .format("YYYY-MM-DD");

                    if (selectedDates.length == 2) {
                        self.filterDates(selectedDates);
                    }
                }
            },
            singleDateConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d"
            },
            customersTransaction: customersTransaction,
            customersTransactionFields: [
                {
                    key: "date"
                },
                {
                    key: "transaction_no"
                },
                {
                    key: "activity"
                },
                {
                    key: "action"
                }
            ],
            transactionHistoryFilter: transactionHistoryFilter,
            selectedFilter: 0,
            importCsv: null,
            customerModalImg: {
                hGw: false,
                wGh: false
            },
            selectedCustomer: "",
            range: null,
            permission: permission,
            searchString: "",
            selectedSearchOption: "all",
            privilegeCard: null,
            keyAccountsUuid: {
                local: [
                    "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
                    "5f34dbaf-93e0-46bd-9779-777b7cfccc30" // generika
                ],
                Development: [
                    "8e9bc0ba-aa25-4c75-96d5-b16703916b35" //estore
                ],
                Canary: [
                    "8e9bc0ba-aa25-4c75-96d5-b16703916b35", // estore
                    "5f34dbaf-93e0-46bd-9779-777b7cfccc30" // generika
                ],
                Staging: [
                    "90dd82f7-0e39-430c-9647-cdf7e3741708" // generika
                ],
                Release: [
                    "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
                    "e07df259-aae6-4ea8-b507-b07f08131727" // generika
                ],
                Production: [
                    "d52635e6-5363-4f7b-9119-d5c64fad8a09", // estore
                    "e07df259-aae6-4ea8-b507-b07f08131727" // generika
                ]
            },
            keyAccount: null,
            importInProgressUuids: [],
            importCompleteUuids: [],
            moment,
            storedFilter: {},
            emptySearch: null,
            selectedTabIndex: 0
        };
    },
    computed: {
        ...mapState("customers", [
            "error",
            "errors",
            "loading",
            "view",
            "list",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "startList",
            "endList",
            "message",
            "customer",
            "importBase",
            "form",
            "amountSpent",
            "pointEarned",
            "pointsRedeemed",
            "import",
            "uuid",
            "merchantUuid",
            "cardNumbers",
            "currentBalance",
            "importUuid", // Specific UUID
            "importUuids",
            "summaryCount"
        ]),
        ...mapState("transactions", {
            historyCount: state => state.historyCount,
            transactionsErrors: state => state.errors
        }),
        ...mapState("reportsStores", ["store_modal", "membership_id", "param"]),
        ...mapState("auth", ["enabledTopUps", "user"]),
        ...mapState("merchants", {
            meta: state => state.meta,
            merchantLoading: state => state.loading
        }),
        ...mapState("analytics", ["isSegmentAnalyticsReady"]),
        ...mapGetters("customers", ["searchParameters"]),
        filterDateFrom() {
            return this.filter.dateFrom;
        },
        filterDateTo() {
            return this.filter.dateTo;
        },
        daterangeConfigHistory: {
            get: function () {
                let _this = this;
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    defaultDate: ["today", "today"],
                    onChange: function (selectedDates) {
                        _this.selectedDate(selectedDates);
                        _this.range = selectedDates;
                    }
                };
            }
        },
        statistics() {
            const year = this.summaryCount.year
                ? this.summaryCount.year
                : new Date().getFullYear();

            const month = this.summaryCount.month
                ? this.summaryCount.month
                : new Date().toLocaleString("default", {
                    month: "long"
                });

            const note = this.summaryCount.created_at
                ? `Data as of ${this.$moment(
                    this.summaryCount.created_at
                ).format(
                    "YYYY/MM/DD, hh:mm a"
                )}. For latest reading, we advise checking again on the next hour.`
                : "";

            return [
                {
                    note,
                    display: `${year} Registrations`,
                    value:
                        "yearly_count" in this.summaryCount
                            ? this.summaryCount.yearly_count
                            : "-",
                    iconBgColor: "rgba(255, 138, 0, 0.08)",
                    icon: "yearly_customer_registration_count.svg"
                },
                {
                    note,
                    display: `${month} Registrations`,
                    value:
                        "monthly_count" in this.summaryCount
                            ? this.summaryCount.monthly_count
                            : "-",
                    iconBgColor: "rgba(81, 130, 255, 0.08)",
                    icon: "monthly_customer_registration_count.svg"
                }
            ];
        },
        isDisabledSearchButton() {
            return !this.filter.keyword;
        },
        emptyText() {
            if (this.loading && !this.filter.keyword) return "Loading data...";

            if (this.loading && this.filter.keyword) return "Searching...";

            if (!this.loading && !this.filter.keyword && this.list.length === 0)
                return "No records found.";
        }
    },
    beforeDestroy() {
        this.filter = initFilter();
    },
    created: function () {
        this.storedFilter = { ...this.filter };
        this.$store.dispatch("customers/getList", { page: 1 });
        this.$store.dispatch("customers/getSummaryCount");
        this.getPrivilegeCard();
        this.showFields();
    },
    methods: {
        imageError(event) {
            event.target.src = require("@/assets/images/Image_error_placeholder.svg");
        },
        capitalizeFirstLetter(string) {
            if (!string) return "";
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        togglePreviewModal(sdId) {
            this.selectSdId = sdId;
            this.imagePreview = sdId.customer_image_front;
            this.openPreviewIdModal = true;
        },
        toggleIdConfirmationModal(uuid, action) {
            this.idAction = action;
            this.selectedIdUuid = uuid;
            this.openIdConfirmationModal = true;
        },
        async updateSpecialdDiscountId() {
            let _this = this;
            this.$store.commit("customers/setErrorState", false);
            let transactionHistoryParam = {
                apiFields: {
                    customer_uuid: [_this.customer.uuid],
                    page: 1
                }
            };

            if (_this.idAction != "void") {
                let param = {
                    uuid: _this.selectedIdUuid,
                    is_approved: _this.idAction == "approve" ? 1 : 0,
                    notes: ""
                };

                await _this.$store
                    .dispatch("customers/updateSdId", {
                        param: param,
                        action: _this.idAction
                    })
                    .then(function () {
                        if (_this.error == false) {
                            _this.$store.dispatch(
                                "customers/listSpecialDiscountIds",
                                _this.customer.uuid
                            );
                            _this.$store.dispatch(
                                "transactions/getCustomerHistory",
                                transactionHistoryParam
                            );
                        }
                    });
            } else {
                let param = {
                    uuid: _this.selectedIdUuid
                };

                await _this.$store
                    .dispatch("customers/voidSdId", param)
                    .then(function () {
                        if (_this.error == false) {
                            _this.$store.dispatch(
                                "customers/listSpecialDiscountIds",
                                _this.customer.uuid
                            );
                            _this.$store.dispatch(
                                "transactions/getCustomerHistory",
                                transactionHistoryParam
                            );
                        }
                    });
            }

            _this.openIdConfirmationModal = false;
        },
        formatDate: function (date) {
            return this.$moment(date).format("MMM D, YYYY HH:mm");
        },
        validateFile(e) {
            const file = e.target.files[0];
            this.filename = file.name;

            this.$store.commit("customers/errors", null);

            if (
                !["application/vnd.ms-excel", ".csv", "text/csv"].includes(
                    file.type
                )
            ) {
                this.$store.commit("customers/errors", {
                    errors: {
                        file: "Invalid file format, only CSV file is accepted."
                    }
                });
            }
        },
        async updateMeta() {
            let payload = {
                merchant_uuid: this.user.merchant_uuid,
                meta_key: "import_customer_notifications",
                value: {
                    is_sms: this.is_sms == true ? 1 : 0,
                    is_in_app: this.is_in_app == true ? 1 : 0
                }
            };

            await this.$store.dispatch("merchants/updateMeta", payload);
        },
        cancelFileUpload() {
            this.$refs.fileinput.reset();
            this.file = null;
            this.filename = "";
            this.$store.commit("customers/errors", null);
        },
        formatBytes(file, decimals = 2) {
            if (file != null) {
                if (file.size === 0) return "0 Bytes";

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = [
                    "Bytes",
                    "KB",
                    "MB",
                    "GB",
                    "TB",
                    "PB",
                    "EB",
                    "ZB",
                    "YB"
                ];

                const i = Math.floor(Math.log(file.size) / Math.log(k));

                return (
                    parseFloat((file.size / Math.pow(k, i)).toFixed(dm)) +
                    " " +
                    sizes[i]
                );
            }
        },
        errorMessage(field) {
            if (!this.errors) return "";

            const { errors } = this.errors;

            return errors[field] ? errors[field] : "";
        },
        validationState(field) {
            if (!this.errors) return false;

            const { errors } = this.errors;

            return !errors[field];
        },
        async openModal() {
            this.$refs.uploadFileModal.show();
        },
        showFields() {
            this.keyAccount = this.keyAccountsUuid[
                process.env.VUE_APP_MODE
            ].find(uuid => uuid == this.merchantUuid);

            if (this.keyAccount !== undefined) {
                return this.generikaFields;
            } else {
                return this.fields;
            }
        },
        async paginate(page) {
            await this.$store
                .dispatch("customers/getList", {
                    page: page,
                    payload: {
                        ...this.storedFilter,
                        keyword: this.storedFilter.keyword
                            ? this.storedFilter.keyword.trim()
                            : null
                    }
                })
                .then(() => this.customEmptySearchString());
        },
        doSearch(evt) {
            if (this.filter.keyword) this.search(evt);
        },
        async search(evt) {
            this.storedFilter = { ...this.filter };

            await this.$store
                .dispatch("customers/getList", {
                    page: 1,
                    payload: {
                        ...this.filter,
                        keyword: this.filter.keyword
                            ? this.filter.keyword.trim()
                            : null
                    }
                })
                .then(() => {
                    if (evt) evt.target.blur();

                    this.customEmptySearchString();
                });
        },
        customEmptySearchString() {
            if (
                !this.loading &&
                this.storedFilter.keyword &&
                this.list.length === 0
            )
                this.emptySearch = `No records found for "${this.storedFilter.keyword.trim()}"`;
            else this.emptySearch = null;
        },
        async editCustomer(uuid) {
            this.selectedTabIndex = 0;
            this.$store.commit("customers/setUuid", uuid);
            await this.$store.dispatch("customers/getProfile");
            this.$store.dispatch("customers/getPointsInfo");
            this.$store.dispatch("customers/getCardNumbers");
            this.$store.dispatch("customers/getCurrentBalance");
            this.$store.dispatch("wallet/getCustomerWallets", uuid);
            this.$store.dispatch(
                "customers/listSpecialDiscountIds",
                this.customer.uuid
            );
            this.selectedCustomer = uuid;
            this.getStoreTransactions();
        },
        async exportCustomer() {
            this.$store.commit("customers/setSearchDefault");
            this.$store.commit("customers/setSearchFilter", this.filter);

            await this.$store.dispatch("customers/exportCustomer");

            if (!this.errors && this.isSegmentAnalyticsReady) {
                window.analytics.track(
                    "Export Customers",
                    this.searchParameters
                );
            }
        },
        browseCSV: function () {
            this.$refs["importCsv"].$el.children[0].click();
        },
        selectedDate(value) {
            let range = {};
            if (value.length == 2) {
                range = {
                    start: this.$moment(value[0]).format("YYYY-MM-DD"),
                    end: this.$moment(value[1]).format("YYYY-MM-DD")
                };

                this.filterDate(range, this.currentPage);
            }
        },
        filterDate(range, page = 1) {
            let param = {
                apiFields: {
                    filter: range,
                    customer_uuid: [this.uuid]
                },
                page: page
            };
            this.$store.dispatch("transactions/filterByDate", param);
        },
        getCustomerTransactionCount(uuid) {
            let param = {
                uuid: uuid
            };

            if (uuid != null)
                this.$store.dispatch(
                    "transactions/getCustomerHistoryCount",
                    param
                );
        },
        customerModal: function () {
            setTimeout(() => {
                let avatar_w = this.$refs.customerProfileImg.clientWidth;
                let avatar_h = this.$refs.customerProfileImg.clientHeight;

                if (avatar_w > avatar_h) this.customerModalImg.wGh = true;

                if (avatar_h > avatar_w) this.customerModalImg.hGw = true;
            }, 700);
        },
        customerModalClose: function () {
            this.customerModalImg.hGw = false;
            this.customerModalImg.wGh = false;
            this.form.birthdate = "0000-00-00";
        },
        async exportTransactionHistory(uuid) {
            let range_param =
                this.range == null ? null : this.getRange(this.range);

            let search_param = {
                category: 1,
                text: [uuid]
            };

            let param = {
                filter: range_param,
                search: search_param
            };

            await this.$store.dispatch("transactions/exportHistory", param);

            if (!this.transactionsErrors && this.isSegmentAnalyticsReady) {
                window.analytics.track("Export Transaction History", param);
            }
        },
        getRange(value) {
            this.range = value;

            let range = {
                start: this.$moment(value[0]).format("YYYY-MM-DD"),
                end: this.$moment(value[1]).format("YYYY-MM-DD")
            };

            return range;
        },
        AddStore: function () {
            this.showAddStore = true;
            this.$refs.CustomerModal.hide();
        },
        cancelAddStore: function () {
            this.$refs.CustomerModal.show();
        },
        EditStore: function () {
            this.showEditStore = true;
            this.$refs.CustomerModal.hide();
        },
        cancelEditStore: function () {
            this.$refs.CustomerModal.show();
        },
        cancelDeleteStore: function () {
            this.$refs.CustomerModal.show();
        },
        getStoreTransactions: async function () {
            await this.$store.dispatch(
                "reportsStores/getCustomerMembershipID",
                {
                    uuid: this.uuid,
                    page: this.page
                }
            );
            await this.$store.dispatch("reportsStores/getList", {
                page: this.param.page,
                membership_id: this.membership_id
            });
        },
        getPrivilegeCard: async function () {
            let _this = this;
            await this.$store.dispatch("auth/getTopUps").then(function () {
                _this.privilegeCard = _this.enabledTopUps.includes(
                    "privilege_card"
                );
            });
        },
        async getBase64(file) {
            return new Promise(function (resolve, reject) {
                const reader = new FileReader();
                reader.onload = function () {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        async showNotification(importStatus) {
            if (importStatus.import_status == "on_process") {
                if (
                    !this.importInProgressUuids.includes(
                        importStatus.import_uuid
                    )
                ) {
                    this.$notify({
                        id: "uploading-import" + importStatus.import_uuid,
                        group: "uploading-import",
                        title:
                            "<span class='uploading'>Uploading</span> <i class='icon-close'></i>",
                        duration: -10
                    });
                }
            } else if (importStatus.import_status == "done") {
                this.importInProgressUuids = this.importInProgressUuids.filter(
                    uuid => uuid !== importStatus.import_uuid
                );
                let closeUploadNotifRef =
                    "upload-close-" + importStatus.import_uuid; //  Get UUID of close button of upload notification
                if (document.getElementById(closeUploadNotifRef) != null) {
                    // Close upload notification if it's done
                    document.getElementById(closeUploadNotifRef).click();
                }
                if (
                    !this.importCompleteUuids.includes(importStatus.import_uuid)
                ) {
                    this.importCompleteUuids.push(importStatus.import_uuid);
                    let titleToBeShown =
                        "<i class='icon-success'></i>" +
                        importStatus.message +
                        "</span> <i class='icon-close-customers-import'></i>";

                    if (!this.errors && this.isSegmentAnalyticsReady) {
                        window.analytics.track("Import Customers", {
                            file_name: this.filename
                        });
                    }

                    this.$notify({
                        id: "success-import" + importStatus.import_uuid,
                        group: "success-import",
                        title: titleToBeShown,
                        duration: 60000
                    });
                }
                //  Remove UUID from importUuids
                this.$store.dispatch(
                    "customers/removeUuidFromImportUuids",
                    importStatus.import_uuid
                );
                // Refresh the table after uploading
                await this.$store
                    .dispatch("customers/getList", {
                        page: 1,
                        payload: {
                            ...this.storedFilter,
                            keyword: this.storedFilter.keyword
                                ? this.storedFilter.keyword.trim()
                                : null
                        }
                    })
                    .then(() => this.customEmptySearchString());
            }
        },
        async checkInitialImportStatus() {
            let _this = this;
            await this.$store
                .dispatch("customers/getImportsStatus", _this.importUuid)
                .then(function (importStatus) {
                    if (importStatus.import_status == "on_process") {
                        _this.importInProgressUuids.push(
                            importStatus.import_uuid
                        );
                        _this.$notify({
                            id: importStatus.import_uuid,
                            group: "uploading-import",
                            title:
                                "<div class='lds-circle'><div></div></div> <span class='uploading'>Uploading</span> <i class='icon-close' id='upload-close-" +
                                importStatus.import_uuid +
                                "' ></i>",
                            duration: -10
                        });
                    }
                });
        },
        async checkImportStatus() {
            if (this.importUuids.length > 0) {
                this.interval = window.setInterval(() => {
                    for (const importUuid of this.importUuids) {
                        let _this = this;

                        this.$store
                            .dispatch("customers/getImportsStatus", importUuid)
                            .then(function (data) {
                                _this.showNotification(data);
                            });
                    }
                }, 5000);
            } else {
                clearInterval(this.interval);
            }
        },
        async uploadFile() {
            const fileInBase64 = this.file
                ? await this.getBase64(this.file)
                : null;

            let param = {
                csv: fileInBase64 ? fileInBase64.split("base64,").pop() : null,
                send_notification: {
                    sms: this.is_sms ? 1 : 0,
                    "in-app": this.is_in_app ? 1 : 0
                }
            };

            let _this = this;
            await this.$store
                .dispatch("customers/importCustomer", param)
                .then(async function () {
                    if (_this.errors == null) {
                        _this.checkInitialImportStatus();
                        _this.checkImportStatus();
                        _this.$refs.uploadFileModal.hide();
                        _this.$refs.fileinput.reset();
                        _this.file = null;
                        _this.is_sms = false;
                        _this.is_in_app = false;
                        await _this.$store
                            .dispatch("customers/getList", {
                                page: 1,
                                payload: {
                                    ...this.storedFilter,
                                    keyword: this.storedFilter.keyword
                                        ? this.storedFilter.keyword.trim()
                                        : null
                                }
                            })
                            .then(() => this.customEmptySearchString());
                    }
                });
        },
        async resetMeta() {
            let payload = {
                merchant_uuid: this.user.merchant_uuid,
                meta_key: "import_customer_notifications",
                value: {
                    is_sms: 0,
                    is_in_app: 0
                }
            };

            await this.$store.dispatch("merchants/updateMeta", payload);
        },
        async filterDates(value) {
            if (value.length == 2) {
                this.storedFilter = { ...this.filter };

                await this.$store
                    .dispatch("customers/getList", {
                        page: 1,
                        payload: {
                            ...this.filter,
                            keyword: this.filter.keyword
                                ? this.filter.keyword.trim()
                                : null
                        }
                    })
                    .then(() => {
                        this.customEmptySearchString();
                    });
            }
        }
    },
    watch: {
        async filterDateTo() {
            await this.$store
                .dispatch("customers/getList", {
                    page: 1,
                    payload: {
                        ...this.storedFilter,
                        keyword: this.storedFilter.keyword
                            ? this.storedFilter.keyword.trim()
                            : null
                    }
                })
                .then(() => this.customEmptySearchString());
        },
        importCsv: function () {
            this.$store.commit("customers/setImportFile", this.importCsv);
            this.$store.dispatch("customers/readImport");
        },
        import: function () {
            if (this.import) {
                let _this = this;
                this.$store
                    .dispatch("customers/importCustomer")
                    .then(async function () {
                        if (_this.errors == null) {
                            await _this.$store
                                .dispatch("customers/getList", {
                                    page: 1,
                                    payload: {
                                        ...this.storedFilter,
                                        keyword: this.storedFilter.keyword
                                            ? this.storedFilter.keyword.trim()
                                            : null
                                    }
                                })
                                .then(() => this.customEmptySearchString());
                        }
                    });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.btn-primary.disabled,
.btn-primary:disabled {
    background-color: #ccc7c4;
    border-color: #ccc7c4;
}

.lds-circle {
    top: 4px;
    position: relative;
    display: inline-block;
    transform: translateZ(1px);
}

.lds-circle>div {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin: 8px;
    border-radius: 50%;
    background: #ff8828;
    animation: lds-circle 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

@keyframes lds-circle {

    0%,
    100% {
        animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);
    }

    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(1800deg);
        animation-timing-function: cubic-bezier(0, 0.5, 0.5, 1);
    }

    100% {
        transform: rotateY(3600deg);
    }
}

#edit-customer .modal-title::after {
    width: 0;
}

.id-preview-modal {
    .modal-content {
        @media (min-width: 1024px) {
            min-width: 660px;
        }
    }

    .modal-header {
        border-bottom: 0 none;
        display: none;
    }

    .modal-footer {
        border-top: 0 none;
        min-height: 30%;
        margin: 0 !important;
        padding: 0 !important;
        display: flex;
        flex-direction: column-reverse;

        @media (min-width: 1024px) {
            display: flex;
            flex-direction: row;
        }
    }

    .preview-modal-btn {
        min-width: 260px !important;
        font-family: MainFontBold, sans-serif;
        font-weight: normal;
        font-size: 16px;
    }

    .modal-title::after {
        display: none;
    }

    .id-preview-image {
        min-height: 40vh;
    }

    p {
        margin: 8px auto !important;
    }

    .img-thumbnail {
        cursor: pointer;
        border: none;
    }
}
</style>
